import { asyncRouterMap, constantRouterMap } from '@/router/index';
import { fetchAnnualJobList } from '@/api/menu'

//判断是否有权限访问该菜单
function hasPermission(menus, route, roles) {
  if (route.name) {
    let currMenu = getMenu(route.name, menus);
    if (currMenu!=null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== '') {
        route.meta.title = currMenu.title;
      }
      if (currMenu.icon != null && currMenu.title !== '') {
        route.meta.icon = currMenu.icon;
      }
      if(currMenu.hidden!=null){
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort;
      }
      //设置管理员账号enableDeletingAuth
      if(roles && roles.includes("超级管理员") && route.props) {
        // if(route.props.enableDeletingAuth == false) {
        //   console.log("测试", route.props)
        //   route.props.enableDeletingAuth = true;
        //   console.log("测试", route.props)
        // }
        
      }

      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort=-1;
        return true;
      } else {
        return false;
      }
    }
  } else {
    return true
  }
}

//根据路由名称获取菜单
function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name===menu.name) {
      return menu;
    }
  }
  return null;
}

//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if(router.children && router.children.length > 0){
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//降序比较函数
function compare(p){
  return function(m,n){
    let a = m[p];
    let b = n[p];
    return b - a;
  }
}

//计算路由数量（包括子路由）
function countRoutes(routers) {
  let count = 0;
  routers.forEach(router => {
    if (!router.hidden) {
      count++;
      if (router.children && router.children.length > 0) {
        count += countRoutes(router.children);
      }
    }
  });
  return count;
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    permissionPageCount: 0
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
    SET_PERMISSION_PAGE_COUNT: (state, count) => {
      state.permissionPageCount = count;
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { menus } = data;
        const { username, roles } = data;
        
        // 首先过滤出有权限的路由
        const accessedRouters = asyncRouterMap.filter(v => {
          if (hasPermission(menus, v, roles)) {
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter(child => {
                if (hasPermission(menus, child, roles)) {
                  return child
                }
                return false;
              });
              return v
            } else {
              return v
            }
          }
          return false;
        });

        // 获取异步页面数据
        fetchAnnualJobList().then(response => {
          const pages = response.data;
          if (pages && pages.length > 0) {
            // 创建深拷贝以避免修改原始路由对象
            // const finalRouters = JSON.parse(JSON.stringify(accessedRouters));
            const finalRouters = accessedRouters;
            
            pages.forEach(page => {
              try {
                const jsonMeta = JSON.parse(page.meta);
                const componentView = jsonMeta.component;
                // 动态导入组件
                jsonMeta.component = () => import(`@/views/files/${componentView}`);
                
                // 查找匹配的父路由
                const parentRoute = finalRouters.find(route => route.name === page.parentName);
                if (parentRoute) {
                  
                  if (!parentRoute.children) {
                    parentRoute.children = [];
                  }
                  parentRoute.children.push(jsonMeta);
                } 
                // else {
                //   // 如果没有父路由，直接添加到顶级路由
                //   finalRouters.push(jsonMeta);
                // }
              } catch (e) {
                console.error('Failed to parse page meta:', page.meta, e);
              }
            });

            // 排序路由
            sortRouters(finalRouters);
            commit('SET_ROUTERS', finalRouters);
            // 计算路由数量并设置导航类型
            const pageCount = countRoutes(finalRouters);
            commit('SET_PERMISSION_PAGE_COUNT', pageCount);
            // 设置导航类型
            const navType = pageCount <= 5 ? 'top' : 'side';
            // 调用app模块的SET_NAV_TYPE mutation（使用root commit）
            commit('SET_NAV_TYPE', navType, { root: true });
            resolve(finalRouters);
          } else {
            // 没有异步页面数据，只使用基本路由
            sortRouters(accessedRouters);
            commit('SET_ROUTERS', accessedRouters);
            // 计算路由数量并设置导航类型
            const pageCount = countRoutes(accessedRouters);
            commit('SET_PERMISSION_PAGE_COUNT', pageCount);
            // 设置导航类型
            const navType = pageCount <= 5 ? 'top' : 'side';
            // 调用app模块的SET_NAV_TYPE mutation（使用root commit）
            commit('SET_NAV_TYPE', navType, { root: true });
            resolve(accessedRouters);
          }
        }).catch(error => {
          console.error('Failed to fetch annual job list:', error);
          // 即使请求失败，也使用基本路由
          sortRouters(accessedRouters);
          commit('SET_ROUTERS', accessedRouters);
          resolve(accessedRouters);
        });
      });
    }
  },
  
};

export default permission;




// WEBPACK FOOTER //
// ./src/store/modules/permission.js